"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var qualificationChecks_exports = {};
__export(qualificationChecks_exports, {
  canViewFullQualificationCertificate: () => canViewFullQualificationCertificate,
  editRegisterSettings: () => editRegisterSettings,
  grant: () => grant,
  viewRegisterSettings: () => viewRegisterSettings
});
module.exports = __toCommonJS(qualificationChecks_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_check = require("../check/index.js");
function grant(name, qualificationId) {
  switch (name) {
    case "Expired":
    case "Trainee":
    case "Qualified":
      return import_check.check.or(import_check.check.globalAdmin, import_check.check.hasQualification((0, import_types.qualificationTrainerRole)(qualificationId)));
    case "Trainer":
    case "Coordinator":
      return import_check.check.or(import_check.check.globalAdmin, import_check.check.hasQualification((0, import_types.qualificationCoordinatorRole)(qualificationId)));
    default:
      return (0, import_util.checkExhausted)(name);
  }
}
function viewRegisterSettings(userId, _qualificationId) {
  return import_check.check.named(`View register settings of user ${userId}`, import_check.check.or(import_check.check.globalAdmin, import_check.check.hasUserId(userId)));
}
function editRegisterSettings(userId, _qualificationId) {
  return import_check.check.named(`Edit register settings of user ${userId}`, import_check.check.or(import_check.check.globalAdmin, import_check.check.hasUserId(userId)));
}
function canViewFullQualificationCertificate(entry) {
  return import_check.check.or(
    import_check.check.hasQualification((0, import_types.qualificationCoordinatorRole)(entry.qualificationId)),
    entry.userId == null ? import_check.check.never("No user ID") : import_check.check.hasUserId(entry.userId)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  canViewFullQualificationCertificate,
  editRegisterSettings,
  grant,
  viewRegisterSettings
});
//# sourceMappingURL=qualificationChecks.js.map
